import {
  GET_NOMINEE_DETAILS,
  SET_NOMINEE_FOLIO,
  SET_NOMINEE_COUNT,
} from "../types/manageNominee";

let init = {
  nomineeList: [],
  nomineeFilio: "",
  nomineeCount: [],
};

export default function MfNomineeUpdate(state = init, action) {
  switch (action.type) {
    case GET_NOMINEE_DETAILS:
      return {
        ...state,
        nomineeList: action.payload,
      };
    case SET_NOMINEE_FOLIO:
      return {
        ...state,
        nomineeFilio: action.payload,
      };
    case SET_NOMINEE_COUNT:
      return {
        ...state,
        nomineeCount: action.payload,
      };

    default:
      return state;
  }
}

